import getCanInitiallyAutoplay from "selectors/device/getCanInitiallyAutoplay";
import { createSelector } from "reselect";

const getReceivedUserInteractionState = (state) =>
  state.userInteraction.receivedUserInteraction;

const getReceivedUserInteraction = createSelector(
  [getCanInitiallyAutoplay, getReceivedUserInteractionState],
  (canInitiallyAutoplay, receivedUserInteractionState) =>
    canInitiallyAutoplay || receivedUserInteractionState,
);

export default getReceivedUserInteraction;
